export default "__VITE_ASSET__Dh2e2ovi__"